import React, { useEffect, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

export const ErrorHandler = ({ error }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!!error?.message) {
      setOpen(true);

      const timer = setTimeout(() => {
        setOpen(false);
      }, 6000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [error]);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity="error" onClose={() => setOpen(false)}>
        Error: {error?.message}
      </Alert>
    </Snackbar>
  );
};
